document.addEventListener("DOMContentLoaded", function () {

  const hiddenInput = document.getElementById("gg-selected-color");
  const buttons = document.querySelectorAll(".gg-color");

  if (!hiddenInput || buttons.length === 0) return;

  // Standaardkleur
  hiddenInput.value = "Wit";

  buttons.forEach(button => {

    button.addEventListener("click", function () {

      buttons.forEach(btn => btn.classList.remove("active"));

      this.classList.add("active");

      hiddenInput.value = this.dataset.color;
      const colorName = document.getElementById("gg-selected-color-name");

if (colorName) {
    colorName.textContent = this.dataset.color;
}
if (previewColor) {
    previewColor.textContent = this.dataset.color;
}
const previewColors = {
    "Wit": "#ffffff",
    "Ecru": "#f4efe4",
    "Champagne": "#d8c3a5",
    "Lichtbruin": "#b98b63",
    "Chocoladebruin": "#5c3a22",
    "Oudroze": "#d89ca5",
    "Babyblauw": "#a8d8ff",
    "Pastelblauw": "#77b5fe",
    "Marineblauw": "#1d3f72",
    "Olijfgroen": "#78866b",
    "Grijs": "#9b9b9b"
};

if (previewName && previewColors[this.dataset.color]) {
    previewName.style.color = previewColors[this.dataset.color];
}

    });

  });



const selectedFont = document.getElementById("gg-selected-font");
const fontCards = document.querySelectorAll(".gg-font-card");
const customFont = document.getElementById("gg-custom-font");

if (selectedFont && fontCards.length) {

  fontCards.forEach(card => {

    card.addEventListener("click", function () {

      fontCards.forEach(c => c.classList.remove("active"));

      this.classList.add("active");

      selectedFont.value = this.dataset.font;
      if (previewName) {
    previewName.style.fontFamily = this.dataset.font;
}

      if (customFont) {
        if (this.dataset.font === "Lettertype zoals geboortekaartje") {
          customFont.style.display = "block";
        } else {
          customFont.style.display = "none";
        }
      }

    });

  });

}
const nameInput = document.querySelector('input[name="properties[Naam]"]');
const characterCount = document.getElementById("gg-character-count");
const previewName = document.getElementById("gg-preview-name");
const previewColor = document.getElementById("gg-preview-color");
const previews = document.querySelectorAll(".gg-live-name");

if (nameInput && previews.length) {

  function updatePreview() {

    const text = nameInput.value.trim() || "Abc";

    previews.forEach(preview => {
      preview.textContent = text;
    });
    if (previewName) {
    previewName.textContent = text;
}
    if (characterCount) {
    characterCount.textContent = nameInput.value.length;
}

  }

  updatePreview();

  nameInput.addEventListener("input", updatePreview);

}
const uploadInput = document.getElementById("gg-upload");

if (uploadInput) {

    uploadInput.addEventListener("change", function () {

        const text = document.querySelector(".gg-upload-content strong");

        if (this.files.length > 0) {

            text.textContent = this.files[0].name;

        } else {

            text.textContent = "Klik hier om je geboortekaartje te uploaden";

        }

    });

}
});